import {
  MANAGE_LEGACY_RULESET_FAIL,
  MANAGE_LEGACY_RULESET_SUCCESS,
  MANAGE_LEGACY_RULESET_TITLE
} from '@bo-constants/member/memberCopy';
import { Combobox } from '@library/components/selects';
import { MemberConfirmationModal } from '@bo-components/members/modal';
import { cn } from '@library/component-utils/cn';
import { isConfirmationErrorMessage } from '@bo-utils/members/memberCommon';
import { useMemberLegacyRulesets } from '@bo-hooks/members';
import { useMemo } from 'react';

export interface MemberManageLegacyRulesetsModalProps {
  memberId: string;
  memberRulesetId?: number;
  memberRulesetName?: string;
  onClose: () => void;
}

export const MemberManageLegacyRulesetsModal = ({
  memberId,
  memberRulesetId = undefined,
  memberRulesetName = undefined,
  onClose
}: MemberManageLegacyRulesetsModalProps) => {
  const {
    isLoading,
    isSubmitError,
    isSubmitSuccess,
    memberRulesetOptions,
    onRulesetChange,
    onSubmit,
    selectedRuleset
  } = useMemberLegacyRulesets({ memberId, memberRulesetId, memberRulesetName });

  const showConfirmationMessage = isSubmitError || isSubmitSuccess;
  const isButtonDisabled = isLoading || !selectedRuleset;

  const UpdateMemberRuleset = useMemo(() => {
    return (
      <div className="text-soClean-180 flex flex-col text-sm">
        <Combobox
          closeMenuOnSelect
          disabled={isLoading}
          id="memberManageLegacyRulesets"
          isMulti={false}
          label="Member ruleset"
          labelClassName="text-soClean-180 text-sm leading-8"
          onChange={onRulesetChange}
          optionClassName="font-heebo text-sm px-3 py-1 rounded bg-soFresh-110 capitalize"
          options={memberRulesetOptions}
          placeholder="Select ruleset"
          value={selectedRuleset}
        />
      </div>
    );
  }, [isLoading, memberRulesetOptions, onRulesetChange, selectedRuleset]);

  const ConfirmationMessage = useMemo(() => {
    const confirmationMessage = isSubmitSuccess
      ? MANAGE_LEGACY_RULESET_SUCCESS
      : MANAGE_LEGACY_RULESET_FAIL;
    const isErrorMessage = isConfirmationErrorMessage(confirmationMessage);

    return (
      <p
        className={cn('text-soClean-180 text-sm', {
          'text-roses': isErrorMessage
        })}
      >
        {confirmationMessage}
      </p>
    );
  }, [isSubmitSuccess]);

  return (
    <MemberConfirmationModal
      cancelCopy="Cancel"
      childrenClassName="justify-evenly min-h-32"
      className="w-[25rem]"
      confirmationCopy="Save"
      handleConfirm={onSubmit}
      isConfirmDisabled={isButtonDisabled}
      isOpen
      label={MANAGE_LEGACY_RULESET_TITLE}
      onCancelModal={onClose}
      showConfirmationMessage={showConfirmationMessage}
    >
      {!showConfirmationMessage ? UpdateMemberRuleset : ConfirmationMessage}
    </MemberConfirmationModal>
  );
};
